import { appNameConstants, LabsterClient } from '@zg-rentals/particles-js-labster';
import requester from 'app/shared/utils/requester';

const labster = new LabsterClient({
    appName: appNameConstants.ZRM,
    proxyPath: 'rental-manager/labster-proxy',
    requester,
});


export default labster;
